<div class="dialog-container">
  <div class="dialog-header">
    <div class="user-edit-icon" [ngSwitch]="selected_dialog_mode">
      <!-- <img src="assets/images/user-circle.png" class="dialog-icon" alt="User Icon" /> -->
        <img *ngSwitchCase="'allergy'" src="assets/images/health/icons/dtopico/Group 15 (5).svg" class="add-icon" alt="Allergy Icon" />
        <img *ngSwitchCase="'medicalcondition'" src="assets/images/health/icons/med-rep.png" class="add-icon" style="width:30px; height: 30px;" alt="Medical Condition Icon" />
        <img *ngSwitchCase="'familyhistory'" src="assets/images/health/icons/dtopico/Group 15 (4).svg" class="add-icon" alt="Family History Icon" />
        <img *ngSwitchCase="'insurance'" src="assets/images/health/icons/dtopico/Group 15 (6).svg" class="add-icon" alt="Insurance Icon" />
        <img *ngSwitchCase="'immunization'" src="assets/images/health/healthlogico/immunization.png" class="add-icon" alt="Immunization Icon" />
    </div>
    <div class="header-text">
      <h2 class="addmed">
        {{ dialogMode === 'add' ? 'Add' : 'Edit' }}
           {{ getDialogTitle(selected_dialog_mode) }}
      </h2>
    </div>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <form [formGroup]="myForm" class="dialog-form">

      <!-- ========== MEDICAL CONDITION ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'medicalcondition'">
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Condition Name </mat-label>
            <input
                matInput
                formControlName="conditionName"
                [matAutocomplete]="auto"
                placeholder="e.g., Hypertension"
            />
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let condition of filteredConditions" [value]="condition.title">
                {{ condition.title}}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="getError('conditionName') as err">{{ err }}</mat-error>
            </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Year of Diagnosis </mat-label>
             
              <input 
                matInput
                placeholder="YYYY"
                readonly
                [value]="selyear"
                [max]="today"
                [min]="minyear"
                [matDatepicker]="picker" 
                (focus)="picker.open()" 
                (click)="picker.open()"/>

              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

              <mat-datepicker
                #picker
                startView="multi-year"
                (yearSelected)="selectYear($event, picker)"
                (monthSelected)="$event.stopPropagation()">
              </mat-datepicker>
           
          </mat-form-field>
          <mat-error *ngIf="myForm.get('yearOfDiagnosis')?.hasError('required') && submitted">
                Year is required.
            </mat-error>
            <mat-error *ngIf="(myForm.get('yearOfDiagnosis')?.hasError('min') || myForm.get('yearOfDiagnosis')?.hasError('max')) && submitted">
                Please enter a valid year between 1900 and {{ currentYear }}.
            </mat-error>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comment</mat-label>
          <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>
      </ng-container>

      <!-- ========== ALLERGY ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'allergy'">
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Allergic To </mat-label>
            <input matInput formControlName="allergicTo" placeholder="e.g., Peanuts" />
            <mat-error *ngIf="getError('allergicTo') as err">{{ err }}</mat-error>
          </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
            <mat-label>Allergic Reactions </mat-label>
            <mat-select formControlName="allergicReaction" multiple>
                <mat-option *ngFor="let reaction of allergReactions" [value]="reaction.title">
                {{ reaction.title }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="getError('allergicReaction') as err">{{ err }}</mat-error>
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Severity </mat-label>
          <mat-select formControlName="severity">
            <mat-option value="low">Low</mat-option>
            <mat-option value="medium">Medium</mat-option>
            <mat-option value="high">High</mat-option>
          </mat-select>
          <mat-error *ngIf="getError('severity') as err">{{ err }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comment</mat-label>
          <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>
      </ng-container>

      <!-- ========== FAMILY HISTORY ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'familyhistory'">
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Condition Name </mat-label>
            <input
                matInput
                formControlName="conditionName"
                [matAutocomplete]="auto"
                placeholder="e.g., Hypertension"
            />
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let condition of filteredConditions" [value]="condition.title">
                {{ condition.title}}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="getError('conditionName') as err">{{ err }}</mat-error>
            </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Relationship </mat-label>
             <mat-select required formControlName ="relationship"  placeholder="e.g., Father" multiple>    
            <mat-option *ngFor="let item of fam_historty_list" value = "{{item}}">
                {{item | titlecase }}
            </mat-option>
            </mat-select>
            <mat-error *ngIf="getError('relationship') as err">{{ err }}</mat-error>
          </mat-form-field>
          
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comment</mat-label>
          <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>
      </ng-container>

      <!-- ========== INSURANCE ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'insurance'">
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Insurance Company </mat-label>
            <input matInput formControlName="insuranceCompany" />
            <mat-error *ngIf="getError('insuranceCompany') as err">{{ err }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Policy Number </mat-label>
            <input matInput formControlName="policyNumber" />
            <mat-error *ngIf="getError('policyNumber') as err">{{ err }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Member ID</mat-label>
            <input matInput formControlName="memberId" />
            <mat-error *ngIf="getError('memberId') as err">{{ err }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Group Number</mat-label>
            <input matInput formControlName="groupNumber" />
            <mat-error *ngIf="getError('groupNumber') as err">{{ err }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Start Date</mat-label>
            <input readonly [matDatepicker]="startDate" matInput formControlName="startDate" (focus)="startDate.open()" (click)="startDate.open()"/>
            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="half-width">
            <mat-label>End Date</mat-label>
            <input  readonly  [min]="end_min_value(myForm.get('startDate')?.value)" [matDatepicker]="endDate" matInput formControlName="endDate" (focus)="endDate.open()" (click)="endDate.open()"/>
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Plan Name </mat-label>
          <input matInput formControlName="planName" />
          <mat-error *ngIf="getError('planName') as err">{{ err }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Status </mat-label>
          <mat-select formControlName="status">
            <mat-option value="active">Active</mat-option>
            <mat-option value="inactive">Inactive</mat-option>
          </mat-select>
          <mat-error *ngIf="getError('status') as err">{{ err }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comment</mat-label>
          <textarea matInput formControlName="comment"></textarea>
          <mat-error *ngIf="getError('comment') as err">{{ err }}</mat-error>
        </mat-form-field>
      </ng-container>

      <!-- ========== IMMUNIZATION ========== -->
      <ng-container *ngIf="selected_dialog_mode === 'immunization'">
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-100">
                <mat-label>Vaccine Name </mat-label>
                <mat-select formControlName="vaccineName">
                    <mat-option *ngFor="let vaccine of immunization" [value]="vaccine.title">
                    {{ vaccine.title }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="getError('vaccineName') as err">{{ err }}</mat-error>
            </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Administered Date </mat-label>
            <input [matDatepicker]="adminDate" [max]="today" matInput formControlName="adminDate" (focus)="adminDate.open()" (click)="adminDate.open()"/>
            <mat-error *ngIf="getError('adminDate') as err">{{ err }}</mat-error>
            <mat-datepicker-toggle matSuffix [for]="adminDate"></mat-datepicker-toggle>
            <mat-datepicker #adminDate></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Next Due Date</mat-label>
          <input [matDatepicker]="nextDueDate" [min]="tomorrow" matInput formControlName="nextDueDate" (focus)="nextDueDate.open()" (click)="nextDueDate.open()"/>
          <mat-datepicker-toggle matSuffix [for]="nextDueDate"></mat-datepicker-toggle>
          <mat-datepicker #nextDueDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Detail</mat-label>
          <textarea matInput formControlName="detail"></textarea>
        </mat-form-field>
      </ng-container>

    </form>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onSubmit()">Save</button>
  </div>
</div>
